module.exports = __webpack_public_path__ + "static/media/shot.19708a60.wav";


//////////////////
// WEBPACK FOOTER
// ./src/game/assets/sounds/shot.wav
// module id = 57
// module chunks = 0